module.exports = __webpack_public_path__ + "img/kawamura.7c0b3897.jpg";